import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b5b415fc&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=b5b415fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b415fc",
  null
  
)

export default component.exports